/**
 * <gx-footer-accordion>
 *
 * Mobile-only accordion for the footer's Nos Marques Vedettes / Categories /
 * Information sections: one section open at a time (same behavior as
 * <gx-menu-drawer>'s submenu accordion). On desktop (990px+) gx-footer.css
 * forces `.gx-footer-section__content` visible regardless of the `hidden`
 * attribute this file toggles, so no breakpoint check is needed here.
 */
class GxFooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.toggles = Array.from(this.querySelectorAll('.gx-footer-section__toggle'));
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', this.onToggleClick.bind(this));
    });
  }

  onToggleClick(event) {
    const toggle = event.currentTarget;
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';

    this.toggles.forEach((otherToggle) => {
      if (otherToggle !== toggle) this.collapseSection(otherToggle);
    });

    isOpen ? this.collapseSection(toggle) : this.expandSection(toggle);
  }

  expandSection(toggle) {
    const content = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!content) return;

    toggle.setAttribute('aria-expanded', 'true');
    content.hidden = false;
  }

  collapseSection(toggle) {
    const content = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!content) return;

    toggle.setAttribute('aria-expanded', 'false');
    content.hidden = true;
  }
}

customElements.define('gx-footer-accordion', GxFooterAccordion);

/**
 * "Back to top" button vs. the WhatsApp floating button (sk-whatsapp-chat-
 * button app, not part of this theme — its markup/shadow DOM is never
 * touched here, only whether it's present at all is checked).
 *
 * An IntersectionObserver on the footer (cheaper than a scroll listener:
 * it doesn't run on every scroll frame, only when the footer's visibility
 * actually changes) toggles a class on <body>; gx-footer.css does the
 * actual crossfade between the two buttons.
 */
function initGxScrollTop() {
  const footer = document.querySelector('.gx-footer');
  const scrollTopButton = document.querySelector('.gx-scroll-top');
  if (!footer || !scrollTopButton) return;

  const observer = new IntersectionObserver(
    (entries) => {
      document.body.classList.toggle('gx-footer-in-view', entries[0].isIntersecting);
    },
    { threshold: 0 }
  );
  observer.observe(footer);

  scrollTopButton.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGxScrollTop);
} else {
  initGxScrollTop();
}
